import { useEffect } from 'react'

/**
 * `vaul`'s own scroll-lock trick only activates on Safari (UA-gated inside
 * the library). On every other browser/WebView, the page behind an open
 * drawer/sheet keeps scrolling unless locked explicitly — so this hook does
 * it at the app level instead of relying on the library's partial behavior.
 */
export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return undefined

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = previousOverflow
    }
  }, [locked])
}
